export enum UnitTilePropertyType {
  SYSTEM = 'System',
  PLACEMENT_PROPERTY = 'Placement property',
  DEV_SPECIFICATION = 'Dev specification'
}

export const unitTileIsDefaultOptions = [
  { label: 'Yes', value: true },
  { label: 'No', value: false },
];
